import type {Result, UseCase} from 'framework';
import type {CatalogExercise} from '../../domain/catalog-exercise';
import type {ExerciseId} from '../../domain/exercise-id.value-object';
import type {WorkoutError} from '../../domain/errors';
import type {ExerciseCatalogRepository} from '../ports/exercise-catalog.repository';

export class GetCatalogExercise implements UseCase<[ExerciseId], CatalogExercise> {
  constructor(private readonly repository: ExerciseCatalogRepository) {}

  execute(id: ExerciseId): Promise<Result<CatalogExercise, WorkoutError>> {
    return this.repository.getById(id);
  }
}
